<form
  [wlTrackStep]="trackStep()"
  [formGroup]="form()"
  (ngSubmit)="formSubmit.emit()"
>
  <rfa-address [form]="form().controls.address" />

  <fieldset class="position-relative">
    <rfa-text-input
      class="consumption-per-year"
      [control]="form().controls.consumption"
    />
    <button
      type="button"
      class="estimate-button btn btn-link p-0"
      wlAutomationId="solar-panels-wizard-estimate-button"
      (click)="openConsumptionDialog.emit()"
    >
      {{ rendering() | scFieldValue: 'ElectricityEstimateButton' }}
    </button>
  </fieldset>

  <rfa-radio-group [control]="form().controls.houseType" />
  <rfa-submit
    [submitState]="submitState()"
    automationId="solarPanelsWizardForm-submit"
  >
    {{ rendering() | scFieldValue: 'SubmitButtonText' }}
  </rfa-submit>
  @if (submitState().status === 'ERROR') {
    <rfa-submit-error wlAutomationId="solar-panels-wizard-submission-error" />
  }
</form>
